import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useReorderDisapprovalReasons(shop: ShopDto) {
	return useApiMutation("patch", "/shops/{shopId}/disapproval-reasons/order", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (ids: string[]) => ({
			params: { path: { shopId: shop.id } },
			body: { ids },
		}),
	});
}
